import React from 'react';

export default ({ message, type }) => (
	<p class={`alert ${type} filled`} role="alert">
		<span class="alert-icon alert-icon-variant"></span>
		<span class="alert-text">{message}</span>
		<span class="control">
			{/*}	<button class="icon-button secondary medium" onclick="">
				<svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24">
					<title>cross</title>
					<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
						<line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
					</g>
				</svg>
</button> {*/}
		</span>
	</p>
)